/* Flash Sale Deal — horizontal scroll arrows for the collection carousel.
   Pure native scroll (no theme carousel dependency), so the layout can never
   be resized by the shared slider component. */
class FlashSaleDeal extends HTMLElement {
  connectedCallback() {
    this.scroller = this.querySelector('[data-fsd-scroller]');
    if (!this.scroller) return;

    this.onArrow = this.onArrow.bind(this);
    this.updateArrows = this.updateArrows.bind(this);

    this.arrows = this.querySelectorAll('[data-fsd-arrow]');
    this.arrows.forEach((btn) => btn.addEventListener('click', this.onArrow));
    this.scroller.addEventListener('scroll', this.updateArrows, { passive: true });
    window.addEventListener('resize', this.updateArrows);
    this.updateArrows();
  }

  disconnectedCallback() {
    if (this.arrows) this.arrows.forEach((btn) => btn.removeEventListener('click', this.onArrow));
    if (this.scroller) this.scroller.removeEventListener('scroll', this.updateArrows);
    window.removeEventListener('resize', this.updateArrows);
  }

  onArrow(evt) {
    const dir = evt.currentTarget.dataset.fsdArrow === 'next' ? 1 : -1;
    const rtl = document.dir === 'rtl';
    this.scroller.scrollBy({ left: dir * (rtl ? -1 : 1) * this.scroller.clientWidth * 0.85, behavior: 'smooth' });
  }

  updateArrows() {
    const max = this.scroller.scrollWidth - this.scroller.clientWidth - 1;
    const x = Math.abs(this.scroller.scrollLeft);
    this.classList.toggle('fsd--at-start', x <= 1);
    this.classList.toggle('fsd--at-end', x >= max);
    this.classList.toggle('fsd--no-scroll', max <= 1);
  }
}

if (!customElements.get('flash-sale-deal')) {
  customElements.define('flash-sale-deal', FlashSaleDeal);
}
